import SearchableSelect from 'views/molecules/SearchableSelect/SearchableSelect';

export default SearchableSelect;
